import _, { drop } from 'lodash';
import createjs from 'createjs-collection';

import * as fJS from './../cjsRoot/fJS';
import { cjsItem } from './../cjsRoot/cjsBase';
import { cjsLine } from './../cjsObjects/cjsLine';
import { cjsPoint } from './../cjsObjects/cjsPoint';
import { cjsEffects } from './../cjsObjects/cjsEffects';
import STORE from '@/store';
import { cjsGroup } from '../cjsRoot/cjsGroup';

var blockMove = false;

export class cjsConnect extends cjsItem {
  _lines = [];
  _line;
  _removedLine = false;

  constructor(obj) {
    super(obj);
    this._line = false;
  }

  stageMouseDown(e, data) {
    if (STORE.getters.lockGame) {
      e.stopPropagation();
      return false;
    }
    console.log('cjsConnect: DOWN - id: ' + data.engine.id);
    let engine = data.engine,
      stage = data.cjsStage,
      mouse = new createjs.Point(Math.floor(e.stageX), Math.floor(e.stageY));

    if (stage.mousedown || engine.block === true) {
      e.stopPropagation();
      return false;
    }
    engine._mousedown = true;
    stage.mousedown = true;

    let idPoint = cjsPoint.prototype.findPoint(engine, mouse);
    if (idPoint === false) {
      e.stopPropagation();
      return;
    }

    engine.points[idPoint].visible = true;
    let st = engine.container.localToGlobal(engine.points[idPoint].x, engine.points[idPoint].y);

    engine.line = new cjsLine(
      _.merge(engine.otherProperty, {
        stage: stage,
        item: engine,
        idPoint: idPoint,
        start: { x: st.x - stage.offset.x, y: st.y - stage.offset.y },
        stop:
          this.freeDrawing === true
            ? { x: st.x - stage.offset.x, y: st.y - stage.offset.y }
            : { x: mouse.x - stage.offset.x, y: mouse.y - stage.offset.y },
      })
    );

    engine.line.redraw('select', stage);

    stage._stage.addChild(engine.line.shape);

    stage.listener.pm = stage._stage.on('pressmove', engine._stageMouseMove, null, false, {
      engine: engine,
      cjsStage: stage,
    });

    e.stopPropagation();
  }

  _stageMouseMove(e, data) {
    let engine = data.engine,
      stage = data.cjsStage,
      mouse = new createjs.Point(Math.floor(e.stageX), Math.floor(e.stageY));
    //    if (stage.mousedown !== true || engine._mousedown !== true) { e.stopPropagation(); return false; }

    engine.line.stop = {
      x: mouse.x - stage.offset.x,
      y: mouse.y - stage.offset.y,
    };
    engine.line.redraw('select', stage);

    if (engine.freeDrawing === true) {
      engine.line.start = {
        x: mouse.x - stage.offset.x,
        y: mouse.y - stage.offset.y,
      };
    }
  }

  stageMouseUp(e, data) {
    console.log('cjsConnect: UP ' + data.engine.idGroup + ' - ' + data.engine.id);
    // console.log(data.engine);
    let engine = data.engine,
      stage = data.cjsStage,
      mouse = new createjs.Point(Math.floor(e.stageX), Math.floor(e.stageY));
    if (stage.mousedown !== true) {
      if (engine.line !== false) stage._stage.removeChild(engine.line.shape);
      stage.mousedown = false;
      engine._mousedown = false;
      e.stopPropagation();
      return;
    }
    stage.mousedown = false;
    engine._mousedown = false;

    let find = stage.getObjectUnderPoint({
      x: mouse.x - stage.offset.x,
      y: mouse.y - stage.offset.y,
    });
    if (find === false) {
      return engine._stopDraw(e, true);
    }
    find.idPoint = cjsPoint.prototype.findPoint(stage.groups[find.idGroup].items[find.idItem], mouse);
    if (find.idPoint === false) {
      return engine._stopDraw(e, true);
    }

    stage.groups[find.idGroup].items[find.idItem].points[find.idPoint].visible = true;
    // console.log(find);
    engine.line.connect.itemB = stage.groups[find.idGroup].items[find.idItem];
    engine.line.connect.idPointB = find.idPoint;

    let connect = engine._checkConnect();

    // connect -> false => ta sama grupa, linia do usunięcia
    // connect -> true => nowa linia
    // connect -> Object => znaleziona w ( item i idLine )

    if (connect === false) {
      return engine._stopDraw(e, true);
    }

    // { idGroup: this.line.connect.idGroup2, idItem: this.line.connect.idItem2, idLine: i };

    if (connect !== true) {
      let line = connect.item.lines[connect.idLine];

      if (line.block === true) {
        return engine._stopDraw(e, true);
      }
      connect.item._removeLine(connect.idLine);
    }

    let poi = stage.groups[find.idGroup].items[find.idItem].container.localToGlobal(
      stage.groups[find.idGroup].items[find.idItem].points[find.idPoint].x,
      stage.groups[find.idGroup].items[find.idItem].points[find.idPoint].y
    );

    engine.line.stop = { x: poi.x - stage.offset.x, y: poi.y - stage.offset.y };

    if (engine.freeDrawing === false) engine.line.redraw('connect', stage);
    else {
      engine.line.redrawFree('connect', stage);
    }

    engine.lines[engine.line.id] = engine.line;
    engine.lines[engine.line.id]._start = _.cloneDeep(engine.line._start);
    engine.lines[engine.line.id]._stop = _.cloneDeep(engine.line._stop);

    let itemA = engine.lines[engine.line.id].connect.itemA,
      itemB = engine.lines[engine.line.id].connect.itemB;

    engine.lines[engine.line.id].isCorrect =
      stage.bruteForce !== true &&
      (Object.keys(itemA.lines).length > itemA.correct.length || Object.keys(itemB.lines).length > itemB.correct.length)
        ? false
        : -1;

    stage.sounds.play(engine.idGroup + '.' + engine.id + '.mouseup');

    engine._stopDraw(e);

    if (stage.autoCheckAllCorrect === true && cjsConnect.checkGameAction.call(this, stage, false) === true) {
      console.log('autoCheckAllCorrect');
      STORE.dispatch('checkGame');
    }
  }

  _removeLine(idLine, hides) {
    console.log('remove line: ' + idLine);

    let line = _.cloneDeep(this.lines[idLine].connect);
    if (this.lines[idLine].block === true) {
      return false;
    }

    if (this.lines[idLine].shape.cacheID !== 0) {
      this.lines[idLine].shape.uncache();
    }

    if (this.hideLineAnimation === true && hides === true) {
      this.lines[idLine].setTime();
      this.lines[idLine].toVisible = false;
      this.lines[idLine].wait = this.waitAnimation;
      this.lines[idLine].remove = true;

      this._removedLine = true;
      return false;
    }

    console.log(idLine + ' REMOVE: ' + this._stage._stage.removeChild(this.lines[idLine].shape));
    delete this.lines[idLine];
  }

  checkPoints(st) {
    let stage = typeof st === 'object' && st !== null ? st : this._stage;
    for (let gr in stage.groups) {
      if (false === stage.groups[gr] instanceof cjsGroup) continue;
      for (let i in stage.groups[gr].items) {
        if (false === stage.groups[gr].items[i] instanceof cjsConnect) continue;
        for (let p in stage.groups[gr].items[i].points) {
          if (
            false === stage.groups[gr].items[i].points[p] instanceof cjsPoint ||
            typeof stage.groups[gr].items[i].points[p] !== 'object' ||
            stage.groups[gr].items[i].points[p] === null
          )
            continue;
          stage.groups[gr].items[i].points[p].visible = false;
        }
      }
    }

    for (let gr in stage.groups) {
      if (false === stage.groups[gr] instanceof cjsGroup) continue;
      for (let i in stage.groups[gr].items) {
        if (false === stage.groups[gr].items[i] instanceof cjsConnect) continue;
        for (let l in stage.groups[gr].items[i].lines) {
          if (
            false === stage.groups[gr].items[i].lines[l] instanceof cjsLine ||
            typeof stage.groups[gr].items[i].lines[l] !== 'object' ||
            stage.groups[gr].items[i].lines[l] === null
          )
            continue;
          let c = stage.groups[gr].items[i].lines[l].connect;
          c.itemA.points[c.idPointA].visible = true;
          c.itemB.points[c.idPointB].visible = true;
        }
      }
    }
  }

  setCorrects(droped) {
    let isCorrect = true;

    if (Object.keys(this.lines).length === 0) {
      return this.isCorrect;
    }

    for (let l in this.lines) {
      if (typeof this.lines == 'undefined' || this.lines == null || false === this.lines[l] instanceof cjsLine) {
        continue;
      }

      this.lines[l].isCorrect = this.lines[l].correct === true ? true : false;
      let itemB = this.lines[l].connectTo().item;
      let line = false;

      if (droped !== true) {
        continue;
      }
      if (this._stage.bruteForce === true) {
        line = this.lines[l].isCorrect === true ? 'good' : 'bad';
      } else {
        line = this.isCorrect === true && itemB.isCorrect === true ? 'good' : 'bad';
      }

      if (this.freeDrawing === false) {
        this.lines[l].redraw(line, this._stage);
      } else {
        this.lines[l].redrawFree(line, this._stage);
      }

      if (line == 'bad' && this._stage.removeInCorrects === true) {
        this.lines[l].block = false;
        this.block = false;
        this._removeLine(l, true);
      }

      if (this._stage.correctBlock === true && line == 'good') {
        this.lines[l].block = true;
        if (this.isCorrect === true) {
          this.block = true;
        }
      }
    }

    return isCorrect;
  }

  _checkConnect(cjsline) {
    let line = typeof cjsline === 'object' && cjsline !== null ? cjsline : this.line;
    if (line.connect.itemA.idGroup === line.connect.itemB.idGroup) return false;
    for (let i in this.lines) {
      if (false === this.lines[i] instanceof cjsLine) continue;
      let l = this.lines[i];
      if (typeof l !== 'object' || l === null) continue;
      if (
        fJS.isEqual(
          {
            idItemA: line.connect.itemA.idc,
            idGroupA: line.connect.itemA.idGroup,
            idItemB: line.connect.itemB.idc,
            idGroupB: line.connect.itemB.idGroup,
          },
          {
            idItemA: l.connect.itemA.idc,
            idGroupA: l.connect.itemA.idGroup,
            idItemB: l.connect.itemB.idc,
            idGroupB: l.connect.itemB.idGroup,
          }
        ) === true ||
        fJS.isEqual(
          {
            idItemA: line.connect.itemA.idc,
            idGroupA: line.connect.itemA.idGroup,
            idItemB: line.connect.itemB.idc,
            idGroupB: line.connect.itemB.idGroup,
          },
          {
            idItemB: l.connect.itemA.idc,
            idGroupB: l.connect.itemA.idGroup,
            idItemA: l.connect.itemB.idc,
            idGroupA: l.connect.itemB.idGroup,
          }
        ) === true
      )
        return {
          item: line.connect.itemA,
          idLine: i,
        };
    }

    for (let i in line.connect.itemB.lines) {
      let l = line.connect.itemB.lines[i];
      if (false === l instanceof cjsLine || typeof l !== 'object' || l === null) continue;
      if (
        fJS.isEqual(
          {
            idItemA: line.connect.itemA.idc,
            idGroupA: line.connect.itemA.idGroup,
            idItemB: line.connect.itemB.idc,
            idGroupB: line.connect.itemB.idGroup,
          },
          {
            idItemA: l.connect.itemA.idc,
            idGroupA: l.connect.itemA.idGroup,
            idItemB: l.connect.itemB.idc,
            idGroupB: l.connect.itemB.idGroup,
          }
        ) === true ||
        fJS.isEqual(
          {
            idItemA: line.connect.itemA.idc,
            idGroupA: line.connect.itemA.idGroup,
            idItemB: line.connect.itemB.idc,
            idGroupB: line.connect.itemB.idGroup,
          },
          {
            idItemB: l.connect.itemA.idc,
            idGroupB: l.connect.itemA.idGroup,
            idItemA: l.connect.itemB.idc,
            idGroupA: l.connect.itemB.idGroup,
          }
        ) === true
      )
        return {
          item: line.connect.itemB,
          idLine: i,
        };
    }

    return true;
  }

  _findConnect() {
    let connect = [];
    for (let gr in this._stage.groups) {
      if (false === this._stage.groups[gr] instanceof cjsGroup || gr === this.idGroup) continue;
      for (let i in this._stage.groups[gr].items) {
        if (false === this._stage.groups[gr].items[i] instanceof cjsConnect) continue;
        for (let l in this._stage.groups[gr].items[i].lines) {
          if (
            false === this._stage.groups[gr].items[i].lines[l] instanceof cjsLine ||
            typeof this._stage.groups[gr].items[i].lines[l] !== 'object' ||
            this._stage.groups[gr].items[i].lines[l] === null
          )
            continue;
          if (
            this._stage.groups[gr].items[i].lines[l].connect.itemA.idGroup === this.idGroup &&
            this._stage.groups[gr].items[i].lines[l].connect.itemA.idc === this.idc
          ) {
            connect.push(
              _.merge(this._stage.groups[gr].items[i].lines[l].connect, {
                idLine: l,
                isCorrect: this._stage.groups[gr].items[i].lines[l].isCorrect,
                source: { idItem: this._stage.groups[gr].items[i].idc, idGroup: gr },
              })
            );
          } else if (
            this._stage.groups[gr].items[i].lines[l].connect.itemB.idGroup === this.idGroup &&
            this._stage.groups[gr].items[i].lines[l].connect.itemB.idc === this.idc
          ) {
            connect.push(
              _.merge(this._stage.groups[gr].items[i].lines[l].connect, {
                idLine: l,
                isCorrect: this._stage.groups[gr].items[i].lines[l].isCorrect,
                source: { idItem: this._stage.groups[gr].items[i].idc, idGroup: gr },
              })
            );
          }
        }
      }
    }

    return connect;
  }

  _stopDraw(e, remove) {
    if (remove === true) {
      this._stage._stage.removeChild(this.line.shape);
    }

    delete this._line;
    this.line = false;

    this.checkPoints();

    this._stage.mousedown = false;
    this._mousedown = false;
    this._stage._stage.off('pressmove', this._stage.listener.pm);

    e.stopPropagation();
    return false;
  }

  get hideLineAnimation() {
    return typeof this.otherProperty.lines === 'object' &&
      typeof this.otherProperty.lines.hideLineAnimation === 'boolean'
      ? this.otherProperty.lines.hideLineAnimation
      : this._stage.defConfig.lines.hideLineAnimation;
  }
  get waitAnimation() {
    return typeof this.otherProperty.lines === 'object' &&
      typeof this.otherProperty.lines.hide === 'object' &&
      fJS.isNumeric(this.otherProperty.lines.hide.wait)
      ? this.otherProperty.lines.hide.wait
      : this._stage.defConfig.lines.hide.wait;
  }

  get freeDrawing() {
    return typeof this.otherProperty.lines === 'object' &&
      this.otherProperty.lines !== null &&
      typeof this.otherProperty.lines.freeDrawing === 'boolean'
      ? this.otherProperty.lines.freeDrawing
      : this._stage.defConfig.lines.freeDrawing;
  }
  get line() {
    return this._line;
  }
  set line(v) {
    this._line = v;
  }
  get lines() {
    return this._lines;
  }
  set lines(v) {
    this._lines = v;
  }
}

cjsConnect.tick = function (stage) {
  for (let gr in stage.groups) {
    if (false === stage.groups[gr] instanceof cjsGroup) continue;
    let lines = [];
    for (let i in stage.groups[gr].items) {
      if (false === stage.groups[gr].items[i] instanceof cjsConnect) continue;
      if (stage.groups[gr].items[i]._removedLine === true) {
        for (let l in stage.groups[gr].items[i].lines) {
          if (false === stage.groups[gr].items[i].lines[l] instanceof cjsLine) continue;
          if (stage.groups[gr].items[i].lines[l].remove === true) {
            stage.groups[gr].items[i].lines[l]._moved = true;
            lines.push({ line: stage.groups[gr].items[i].lines[l], id: i });
          }
        }
      }
    }
    for (let i = 0; i < lines.length; i++) {
      if (cjsEffects[lines[i].line.effect].call(this, lines[i].line) === false) {
        continue;
      }
      if (lines[i].line._moved === false) {
        stage.groups[gr].items[lines[i].id].lines[lines[i].line.id].remove = false;
        console.log(lines[i].line.id + ' REMOVE: ' + stage._stage.removeChild(lines[i].line.shape));
        delete stage.groups[gr].items[lines[i].id].lines[lines[i].line.id];

        let r = false;
        for (let l in stage.groups[gr].items[lines[i].id].lines) {
          if (false === stage.groups[gr].items[lines[i].id].lines[l] instanceof cjsLine) continue;
          if (stage.groups[gr].items[lines[i].id].lines[l].remove === true) {
            r = true;
          }
        }

        stage.groups[gr].items[lines[i].id]._removedLine = r;
        lines[i].line.connect.itemA.checkPoints();
      }
      lines.splice(i, 1);
    }
  }
};

cjsConnect.checkGameAction = function (stage, droped) {
  console.log('cjsConnect CHECK');
  let groups = {};

  for (let gr in stage.groups) {
    if (false === stage.groups[gr] instanceof cjsGroup) continue;
    for (let i in stage.groups[gr].items) {
      let item = stage.groups[gr].items[i];
      if (false === item instanceof cjsConnect) continue;
      item.isCorrect = false;
      for (let l in item.lines) {
        if (false === item.lines[l] instanceof cjsLine) continue;
        item.lines[l].isCorrect = -1;
      }
      if (typeof groups[gr] !== 'object' || groups[gr] === null) groups[gr] = {};
      groups[gr][i] = {
        connects: stage.groups[gr].items[i]._findConnect(),
        correct: _.cloneDeep(item.correct),
        maxCorrect: 0,
        isCorrects: 0,
        left: 0,
        pickCorrect:
          typeof item.otherProperty === 'object' && fJS.isNumeric(item.otherProperty.pickCorrect)
            ? item.otherProperty.pickCorrect
            : false,
      };
      for (let c = 0; c < item.correct.length; c++) {
        if (fJS.isNumeric(item.correct[c].count) !== true) {
          groups[gr][i].maxCorrect++;
          groups[gr][i].correct[c].count = 1;
        } else {
          groups[gr][i].maxCorrect += groups[gr][i].correct[c].count;
        }
      }
      groups[gr][i].left =
        groups[gr][i].correct.length === 0
          ? 0
          : fJS.isNumeric(groups[gr][i].pickCorrect)
          ? groups[gr][i].pickCorrect
          : groups[gr][i].maxCorrect > groups[gr][i].correct.length
          ? groups[gr][i].maxCorrect
          : groups[gr][i].correct.length;
    }
  }

  for (let gr in groups) {
    for (let i in groups[gr]) {
      if (groups[gr][i].connects.length === 0) continue;
      for (let c = 0; c < groups[gr][i].connects.length; c++) {
        let connect = {
          idLine: groups[gr][i].connects[c].idLine,
          isCorrect: groups[gr][i].connects[c].isCorrect,
          idPointA: groups[gr][i].connects[c].idPointB,
          idPointB: groups[gr][i].connects[c].idPointA,
          itemA: groups[gr][i].connects[c].itemB,
          itemB: groups[gr][i].connects[c].itemA,
          source:
            typeof groups[gr][i].connects[c].itemA.lines[groups[gr][i].connects[c].idLine] != 'undefined' &&
            groups[gr][i].connects[c].itemA.lines[groups[gr][i].connects[c].idLine] != null
              ? { idItem: groups[gr][i].connects[c].itemA.idc, idGroup: groups[gr][i].connects[c].itemA.idGroup }
              : { idItem: groups[gr][i].connects[c].itemB.idc, idGroup: groups[gr][i].connects[c].itemB.idGroup },
        };
        if (
          groups[gr][i].connects[c].itemA.idGroup != gr &&
          fJS.findInArray(
            groups[groups[gr][i].connects[c].itemA.idGroup][groups[gr][i].connects[c].itemA.idc].connects,
            { idLine: groups[gr][i].connects[c].idLine }
          ) === false
        ) {
          groups[groups[gr][i].connects[c].itemA.idGroup][groups[gr][i].connects[c].itemA.idc].connects.push(connect);
        } else if (
          groups[gr][i].connects[c].itemB.idGroup != gr &&
          fJS.findInArray(
            groups[groups[gr][i].connects[c].itemB.idGroup][groups[gr][i].connects[c].itemB.idc].connects,
            { idLine: groups[gr][i].connects[c].idLine }
          ) === false
        ) {
          groups[groups[gr][i].connects[c].itemB.idGroup][groups[gr][i].connects[c].itemB.idc].connects.push(connect);
        }
      }
    }
  }

  for (let gr in groups) {
    for (let i in groups[gr]) {
      if (groups[gr][i].maxCorrect == 0 && groups[gr][i].connects.length == 0) {
        stage.groups[gr].items[i].isCorrect = true;
        continue;
      }

      for (let cc = 0; cc < groups[gr][i].connects.length; cc++) {
        let item = false,
          idPoint = false;
        if (groups[gr][i].connects[cc].itemA.idGroup != gr) {
          item = groups[gr][i].connects[cc].itemA;
          idPoint = groups[gr][i].connects[cc].idPointA;
        } else if (groups[gr][i].connects[cc].itemB.idGroup != gr) {
          item = groups[gr][i].connects[cc].itemB;
          idPoint = groups[gr][i].connects[cc].idPointB;
        }
        if (item === false) {
          continue;
        }

        for (let c = 0; c < groups[gr][i].correct.length; c++) {
          if (
            fJS.isEqual(
              fJS.removeProps('count')(groups[gr][i].correct[c]),
              { idItem: item.id, idGroup: item.idGroup, idPoint: idPoint },
              true
            ) === false
          ) {
            continue;
          }

          if (groups[gr][i].pickCorrect === false) {
            if (groups[gr][i].correct[c].idGroup === item.idGroup && groups[gr][i].correct[c].idItem === item.id) {
              if (groups[gr][i].correct[c].count > 0) {
                groups[gr][i].connects[cc].isCorrect = groups[gr][i].connects[cc].isCorrect !== false ? true : false;
                groups[gr][i].correct[c].count--;
              }
              groups[gr][i].left--;
            }
            groups[gr][i].isCorrects = groups[gr][i].maxCorrect - groups[gr][i].left;
          } else {
            if (
              groups[gr][i].correct[c].idGroup === item.idGroup &&
              groups[gr][i].correct[c].idItem === item.id &&
              groups[gr][i].isCorrects < groups[gr][i].pickCorrect
            ) {
              if (groups[gr][i].correct[c].count > 0) {
                groups[gr][i].connects[cc].isCorrect = groups[gr][i].connects[cc].isCorrect !== false ? true : false;
                groups[gr][i].correct[c].count--;
              }
              groups[gr][i].left--;
            }
            groups[gr][i].isCorrects = groups[gr][i].pickCorrect - groups[gr][i].left;
          }
        }
        if (
          groups[gr][i].left === 0 &&
          ((groups[gr][i].pickCorrect !== false && groups[gr][i].isCorrects === groups[gr][i].pickCorrect) ||
            groups[gr][i].isCorrects === groups[gr][i].maxCorrect) &&
          groups[gr][i].connects.length === groups[gr][i].isCorrects
        )
          stage.groups[gr].items[i].isCorrect = true;
      }
    }
  }

  for (let gr in groups) {
    for (let i in groups[gr]) {
      for (let cc = 0; cc < groups[gr][i].connects.length; cc++) {
        if (typeof groups[gr][i].connects[cc].source == 'undefined' || groups[gr][i].connects[cc].source == null)
          continue;
        let item =
          stage.groups[groups[gr][i].connects[cc].source.idGroup].items[groups[gr][i].connects[cc].source.idItem];
        item.lines[groups[gr][i].connects[cc].idLine].correct =
          item.lines[groups[gr][i].connects[cc].idLine].isCorrect !== false &&
          groups[gr][i].connects[cc].isCorrect === true;
      }
    }
  }

  console.log(groups);

  let isCorrect = true;
  for (let gr in stage.groups) {
    if (false === stage.groups[gr] instanceof cjsGroup) continue;

    for (let i in stage.groups[gr].items) {
      if (false === stage.groups[gr].items[i] instanceof cjsConnect) continue;

      stage.groups[gr].items[i].setCorrects(droped !== false);

      isCorrect = stage.groups[gr].items[i].isCorrect === true ? isCorrect : false;
    }
  }

  return isCorrect;
};

cjsConnect.resetGameAction = function (stage) {
  console.log('cjsConnect RESET');
  stage._stage.off('pressmove', stage.listener.pm);
};
